import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePostHog } from 'posthog-js/react';
import { isPostHogConfigured, getSharedEventProperties } from './core';

/**
 * Automatically captures $pageview events on route changes.
 * Mount inside a <BrowserRouter> as a sibling to <Routes>.
 *
 * AnalyticsProvider initializes shared config synchronously before children
 * render; if that ordering changes, this wrapper no-ops instead of calling
 * PostHog's hook outside a configured provider tree.
 */
function ActivePostHogPageviewTracker() {
  const location = useLocation();
  const posthog = usePostHog();

  useEffect(() => {
    if (posthog) {
      posthog.capture('$pageview', getSharedEventProperties());
    }
  }, [location, posthog]);

  return null;
}

export function PostHogPageviewTracker() {
  if (!isPostHogConfigured()) {
    return null;
  }

  return <ActivePostHogPageviewTracker />;
}
